const calculateBasePrice = (quantity, rrp, unit) => {
  switch (unit) {
    case "Gramm": {
      return (100 / quantity) * rrp;
    }
    case "Mililiter": {
      return (100 / quantity) * rrp;
    }
    case "Liter": {
      return rrp / quantity;
    }
    case "Kilogramm": {
      return rrp / quantity;
    }
    default:
      return null;
  }
};

export { calculateBasePrice };
